import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images, gridFree } from "../mock/mock";
import { CheckCircle2 } from "lucide-react";

const points = [
  "Modular, utility-grade power delivered anywhere the grid can't reach",
  "Complete power islands designed, built and supported end-to-end",
  "Seamless integration with renewables and energy storage",
  "Rapid deployment for data centers, mining and remote industry",
];

export default function GridFreePower() {
  return (
    <main>
      <PageHero image={images.gridFree} eyebrow="Power Solutions Division" title="Grid-Free Power. Always On." subtitle={gridFree.body} />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <div className="grid md:grid-cols-2 gap-14 items-center">
            <div>
              <h2 className="oe-heading text-oe-navy text-3xl md:text-4xl mb-6">Power anywhere, without limits</h2>
              <p className="text-muted-foreground leading-relaxed mb-8">Our Power Solutions Division unites world-class engineering to deliver dependable energy for the most demanding, off-grid and grid-constrained environments on earth.</p>
              <ul className="space-y-4">
                {points.map((p) => (
                  <li key={p} className="flex items-start gap-3">
                    <CheckCircle2 size={22} className="text-oe-red shrink-0 mt-0.5" />
                    <span className="text-oe-navy/80">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
            <img src={images.sustainability} alt="Grid-free power plant" className="rounded-lg w-full h-[440px] object-cover shadow-xl" />
          </div>
        </div>
        <div className="oe-navy text-white">
          <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[["24/7", "Always-on power"], ["100%", "Off-grid capable"], ["MW", "Scalable output"], ["Global", "Service network"]].map(([n, l]) => (
              <div key={l}>
                <div className="oe-display text-3xl md:text-5xl mb-2">{n}</div>
                <div className="text-white/70 text-sm">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
